import { Box, SxProps } from '@mui/system';
import { CSSProperties } from 'react';
import StepItem from './item';

const StepList = ({
  sx,
  imgSx,
  itemStyles,
  list,
}: {
  sx?: SxProps;
  imgSx?: { width?: string | number; height?: string | number };
  itemStyles?: CSSProperties;
  list: Array<{
    img: string;
    label: string;
    isCompleted?: boolean;
    isProgress?: boolean;
  }>;
}) => {
  return (
    <Box display={'flex'} justifyContent={'space-between'} sx={sx}>
      {list.map(step => (
        <StepItem
          key={step.label}
          {...step}
          styles={{ opacity: step.isProgress ? 1 : 0.5, ...(itemStyles ?? {}) }}
          imgStyles={{
            width: imgSx?.width,
            height: imgSx?.height,
            ...imgSx,
          }}
        />
      ))}
    </Box>
  );
};

export default StepList;
